<template>
  <div>
    <template v-if="!resultSuccess && !resultError">
      <div class="signUp">
        <header>
          <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/images/head.jpg">
        </header>
        <section>
          <h1>讲坛报名 | 砺远-集思 前沿交叉科学与未来技术讲坛</h1>
          <div class="blueTitle">
            <div class="detailText">
              <strong>元宇宙与未来畅想：人类生命与机械生命的探索与共生</strong>
            </div>
            <div class="spanText">
              <span>探讨人类生命与机械生命的议题</span><br>
              <span>让听众在借助科学仰望星空的同时</span><br>
              <span>更加关注变革中的人类世界</span><br>
            </div>
            <p class="titledesc">
              主讲嘉宾均来自全球一流高等学府和研究机构，由 <strong>2017年诺贝尔化学奖得主Prof.Joachim Frank</strong>研究领域覆盖机械工程、机械与航天工程、电子与计算机工程、生物化学、生物电子、医工交叉等多个前沿交叉方向
            </p>
            <div class="time">
              <span>时间：2022/9/13 - 2022/9/29 </span><br>
              <span>形式：Zoom直播 </span><br>
              <span>*报名成功后，将于9月12日18:00前，以邮件形式发送Zoom会议号及入会密码。</span><br>
            </div>
          </div>

          <div class="mainMake">
            <p><strong>主办单位：</strong></p>
            <p><span>集思未来</span></p>
            <p><span>上海交通大学-集思未来 交叉学科创新设计联合研究中心</span></p>
          </div>

          <div class="formWrapper">
            <el-form ref="rulesForm" :rules="formRules" :model="formData">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="学校" prop="school">
                <el-input v-model="formData.school"></el-input>
              </el-form-item>
              <el-form-item label="专业" prop="direction">
                <el-select v-model="formData.direction" placeholder="请选择" v-show="formData.direction !== '其他'">
                  <el-option
                      v-for="item in directionOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
                <el-input v-model="formData.directionInput" v-show="formData.direction == '其他'">
                  <el-select v-model="formData.direction" slot="prepend" style='width:80px'>
                    <el-option v-for="item in directionOptions" :label="item" :value="item" :key="item"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item label="年级" prop="grade">
                <el-select v-model="formData.grade" placeholder="请选择">
                  <el-option
                      v-for="item in gradeOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机" prop="phone">
                <el-input v-model="formData.phone"></el-input>
              </el-form-item>
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="formData.wechat"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
              <el-form-item label="报名讲座场次（可多选）" prop="partList">
                <el-checkbox-group v-model="formData.partList">
                  <el-checkbox label="9/13 机械自动控制与仿生机器人浅谈 Prof. Michael Geist Littman普林斯顿大学教授">
                    <p> 9/13 机械自动控制与仿生机器人浅谈 Prof. Michael Geist Littman普林斯顿大学教授
                      <span>（名额有限）</span>
                    </p>
                  </el-checkbox>
                  <el-checkbox label="9/15 交叉学科展望：数据科学/生物电子/计算智能在生命监测中的前沿技术与应用 Prof.Maarten De Vos 牛津大学实验室主任">
                    <p> 9/15 交叉学科展望：数据科学/生物电子/计算智能在生命监测中的前沿技术与应用 Prof.Maarten De Vos 牛津大学实验室主任
                      <span>（名额有限）</span></p>
                  </el-checkbox>
                  <el-checkbox label="9/21 诺贝尔化学奖得主对谈：冷冻电镜的重构 Prof. Joachim Frank哥伦比亚大学教授、美国国家科学院院士、诺贝尔奖化学奖得主">
                    <p> 9/21 诺贝尔化学奖得主对谈：冷冻电镜的重构 Prof. Joachim Frank哥伦比亚大学教授、美国国家科学院院士、诺贝尔奖化学奖得主
                      <span>（名额有限）</span></p>
                  </el-checkbox>
                  <el-checkbox
                      label="9/22 医工交叉学科探索：前沿生物电子技术在如脑机接口、器官芯片等新型智能医疗设备开发中的应用Prof. George Malliaras 剑桥大学菲利普亲王讲席教授">
                    <p> 9/22 医工交叉学科探索：前沿生物电子技术在如脑机接口、器官芯片等新型智能医疗设备开发中的应用Prof. George Malliaras 剑桥大学菲利普亲王讲席教授
                      <span>（名额有限）</span></p>
                  </el-checkbox>
                  <el-checkbox label="9/29 诺贝尔生理学/医学奖相关研究主题探索：细胞力学、基于生物材料的流变性质与动力学探索 Prof.Emad Moeendarbary 伦敦大学学院教授">
                    <p> 9/29 诺贝尔生理学/医学奖相关研究主题探索：细胞力学、基于生物材料的流变性质与动力学探索 Prof.Emad Moeendarbary 伦敦大学学院教授
                      <span>（名额有限）</span></p>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>

            <el-button class="submitBtn" @click="submitForm">提交</el-button>
          </div>
        </section>
        <div class="footer"></div>
      </div>
    </template>
    <el-result
        icon="success"
        title="提交成功"
        subTitle="提交成功, 请手动关闭页面"
        v-if="resultSuccess"
    >
      <template slot="extra">
        <!-- <el-button type="primary" size="medium" @click="closePage">关闭页面</el-button> -->
      </template>
    </el-result>
    <el-result
        icon="error"
        title="提交失败"
        subTitle="提交失败, 请稍后再试"
        v-if="resultError"
    >
    </el-result>
  </div>
</template>

<script>
import {delNullProperty} from "@/utils";
import axios from "axios";

export default {
  name: "signUp",
  components: {},

  data() {
    return {
      formRules: {
        name: [{required: true, message: '请填写名字', trigger: 'blur'}],
        school: [{required: true, message: '请填写学校', trigger: 'blur'}],
        direction: [{required: true, message: '请选择专业', trigger: 'change'}],
        grade: [{required: true, message: '请选择年级', trigger: 'change'}],
        email: [{required: true, message: '请填写邮箱', trigger: 'blur'}],
        wechat: [{required: true, message: '请填写微信', trigger: 'blur'}],
        phone: [{required: true, message: '请填写手机', trigger: 'blur'}],
        partList: [{required: true, message: '请选择与会项目', trigger: ['blur，change']}],
      },
      formData: {
        name: '',
        partList: []
      },
      directionOptions: [
        '理工科',
        '传媒艺术电影',
        '人文社科',
        '金融商科',
        '计算机',
        '其他'
      ],
      gradeOptions: [
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上'
      ],
      directionShow: false,
      directionInput: "",
      axios: null,
      errorInfos: {
        // 存放对应输入框的报错信息，在提交的时候统一验证
        name: "",
        phone: "",
        wechat: "",
        email: "",
        grade: "",
        direction: "",
        partList: ""
      },
      resultSuccess: false, // 提交成功
      resultError: false
    }
  },
  created() {

    this.createAxios();
  },


  destroyed() {
    document.documentElement.style.fontSize = "16px";
  },

  methods: {
    createAxios() {
      const origin = location.hostname; //当前访问域名
      let requestBase = "";
      if (process.env.NODE_ENV === "development") {
        requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
      } else {
        if (origin.indexOf("-testserver") > -1) {
          requestBase = process.env.VUE_APP_DEV_API;
        } else {
          requestBase = process.env.VUE_APP_MASTER_API;
        }
      }
      const config = {
        baseURL: requestBase,
        timeout: 30 * 1000, // Timeout
      };

      this.axios = axios.create(config);
    },

    directionShowPopup() { //咨询专业方向
      this.directionShow = true
    },
    // 咨询专业方向
    listenDirection(data) {
      if (data != false) {
        this.direction = data
      }
      this.directionShow = false
    },
    submitForm() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.axios
          .post(
              "/market/setMarketClueByShanghai",
              delNullProperty({
                name: this.formData.name,
                school: this.formData.school,
                phone: this.formData.phone,
                wechat: this.formData.wechat,
                email: this.formData.email,
                grade: this.formData.grade,
                direction: this.formData.direction == '其他' ? this.formData.directionInput : this.formData.direction,
                partList: this.formData.partList,
              })
          )
          .then(({data}) => {
            // 判断错误状态
            const error = data.error;
            if (error.returnCode === 1) {
              this.errorInfos.name = error.returnMessage;
            }
            if (error.returnCode === 0) {
              this.resultSuccess = true;
            }
            loading.close();
          })
          .catch((err) => {
            loading.close();
            this.resultError = true
          });
    }
  }
}
</script>

<style scoped>
.signUp >>> .el-checkbox__label {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 20px;
  white-space: normal;
  word-break: break-all;
}

.signUp >>> .el-form-item__label {
  color: rgb(7, 0, 89);
}

.el-select {
  width: 100%;
}

.signUp {
  background-image: url("https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/images/bg.jpg");
  width: 95%;
  padding: 10px;
  margin: -20px;
  position: absolute;
  overflow-x: hidden;
}

header {
  margin-top: 20px;
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

header img {
  width: 100%;
  margin-bottom: -4px;
}


section {
  background: #fff;
  border-radius: 0 0 15px 15px;
  padding: 20px;
}


.footer {
  height: 50px;
}

.submitBtn {
  width: 100%;
  background-color: rgb(42, 68, 166);
  color: #fff
}


.blueTitle .detailText, .spanText {
  text-align: center;
  margin-bottom: 13px;
  color: #333333;
}

.titledesc {
  text-indent: 2em;
  margin-bottom: 13px;
}

h1, .blueTitle {
  margin-bottom: 13px;
}

.mainMake {
  text-align: center;
  margin: 20px 0;
  border-top: 1px dashed grey;
  padding: 7px 0;

}


h1 {
  color: rgb(7, 0, 89);
  font-size: 18px;
}

.el-checkbox {
  color: rgb(7, 0, 89)
}

.el-checkbox span {
  color: #999;
}
</style>
